import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const SearchFilter = styled.div`
  z-index: -1;
  font-size: 22px;
  color: #4a4a4a;
  text-align: left;
  background-color: #fff;
  padding: 20px;
  border: 0;
  width: 390px;
  top: -57px;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 3px 5px 0 rgba(0, 0, 0, 0.2);
  position: absolute;
  transition: all 0.4s ease;
  left: ${props => (props.open ? '380px' : '-20px')};
  opacity: ${props => (props.open ? '1' : '0')};
  visibility: ${props => (props.open ? 'visible' : 'hidden')};
  top: ${props => (props.customTop ? props.customTop : '-57px')};
  @media (max-width: ${breakpoints.bpTabletPx}) {
    width: 100%;
    left: 0;
    top: 0;
    z-index: 10;
    display: ${props => (props.open ? 'block' : 'none')};
    opacity: 1 !important;
    transition: none;
    position: relative;
  }
`

export default SearchFilter
